import '@angular/localize/init';
export * from './lib/feature-tax-sba-details.module';

export * from './lib/tax-sba-details/feature-tax-sba-details.component';
